import createRoutine from '@/utils/createRoutine'

export const apiDeckIntegrationRoutine = createRoutine('apiDeckIntegrationRoutine')
export const routeNameAfterIntegrationRoutine = createRoutine('routeNameAfterIntegrationRoutine')
export const externalApiDeckIntegrationCompleteRoutine = createRoutine('externalApiDeckIntegrationCompleteRoutine')

export const apiDeckGetters = {
  APIDECK_INTEGRATION: 'APIDECK_INTEGRATION',
  ROUTE_NAME_AFTER_INTEGRATION: 'ROUTE_NAME_AFTER_INTEGRATION',
  APIDECK_ERROR: 'APIDECK_ERROR',
  IS_EXTERNAL_APIDECK_INTEGRATION_COMPLETE: 'IS_EXTERNAL_APIDECK_INTEGRATION_COMPLETE'
}
export const APIDECK_CLEANUP = 'APIDECK_CLEANUP'
